// @flow
import React, { type Node } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string,
  label: string | Node,
  isDisabled?: boolean,
  isRequired?: boolean,
};

export const Legend = ({ label, className, isDisabled, isRequired }: Props) => (
  <legend
    className={classNames(
      'font-bold inline-block mb-2 text-base',
      {
        'text-gray-darker': !isDisabled,
        'text-gray-light': isDisabled,
      },
      className,
    )}
  >
    {label}
    {isRequired && '*'}
  </legend>
);
